export const initExternalLinkModal = () => {
  let modal = null;
  let modalOverlay = null;
  let cancelButton = null;
  let confirmButton = null;
  let currentUrl = '';

  // モーダルHTMLを作成
  const createModal = () => {
    // 既に存在する場合は作成しない
    if (document.getElementById('external-link-modal')) return;

    const modalHTML = `
      <div class="external-modal" id="external-link-modal">
        <div class="external-modal-overlay"></div>
        <div class="external-modal-content">
          <div class="external-modal-body">
            <h3 class="external-modal-title">外部サイトへ移動します。</h3>
            <p class="txt -center_sp_left">ネフィー®サイトをご覧いただきありがとうございます。<br>これより先の外部サイトの内容について、<br class="pc">アルフレッサファーマ株式会社は一切の責任を負いません。</p>
          </div>
          <div class="external-modal-footer">
            <div class="btn-wrap">
              <button class="btn -secondary js-external-cancel">いいえ</button>
              <button class="btn -external js-external-confirm">
                <p class="label">はい</p>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML('beforeend', modalHTML);

    modal = document.getElementById('external-link-modal');
    modalOverlay = modal.querySelector('.external-modal-overlay');
    cancelButton = modal.querySelector('.js-external-cancel');
    confirmButton = modal.querySelector('.js-external-confirm');

    // イベントリスナーを設定
    setupModalEvents();
  };

  // モーダルイベントを設定
  const setupModalEvents = () => {
    // いいえボタンクリック
    cancelButton?.addEventListener('click', closeModal);

    // はいボタンクリック
    confirmButton?.addEventListener('click', () => {
      if (currentUrl) {
        window.open(currentUrl, '_blank', 'noopener');
      }
      closeModal();
    });

    // オーバーレイクリック
    modalOverlay?.addEventListener('click', closeModal);
  };

  // モーダルを開く
  const openModal = () => {
    modal.classList.add('-active');
    document.body.style.overflow = 'hidden';

    // フォーカス管理
    setTimeout(() => {
      cancelButton?.focus();
    }, 100);
  };

  // モーダルを閉じる
  const closeModal = () => {
    modal.classList.remove('-active');
    document.body.style.overflow = 'auto';
    currentUrl = '';
  };

  // .js-external-linkクラスを持つリンクにイベントを追加
  document.addEventListener('click', (e) => {
    const externalLink = e.target.closest('.js-external-link');
    if (externalLink) {
      e.preventDefault();
      currentUrl = externalLink.href;

      // 初回クリック時にモーダルを作成
      createModal();
      openModal();
    }
  });

  // ESCキー（グローバルイベント）
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal && modal.classList.contains('-active')) {
      closeModal();
    }
  });
};
